import React from 'react';
import { SvgIcon } from '@mui/material';

export function ImportFileIcon(props: any) {
  return (
    <SvgIcon {...props}>
      <path d="M 13 2 H 6 C 4.9 2 4.01 2.9 4.01 4 L 4 20 c 0 1.1 0.89 2 1.99 2 H 18 c 1.1 0 2 -0.9 2 -2 V 8 C 20 7.3 19.75 6.75 19.4 6.45 L 15.626 2.602 C 15.3 2.3 14.75 2 14 2 z M 18 19 C 18 19.7 17.7 20 17 20 H 7 C 6.3 20 6 19.7 6 19 L 6 5 C 6 4.3 6.3 4 7 4 h 6 L 13 8 C 13 8.7 13.3 9 14 9 h 4 L 18 19 z M14.8,15H13v3c0,0.55-0.45,1-1,1s-1-0.45-1-1v-3H9.21c-0.45 0-0.67-0.54-0.35-0.85l2.8-2.79 c0.2-0.19,0.51-0.19,0.71,0l2.79,2.79C15.46,14.46,15.24,15,14.8,15z" />
    </SvgIcon>
  );
}
